import { useState } from 'react';
import { X } from 'lucide-react';

export default function PaymentMethodModal({ 
  isOpen, 
  onClose, 
  onConfirm, 
  isLoading 
}) {
  console.log('here');
  
  const [selectedMethod, setSelectedMethod] = useState('');

  const paymentMethods = [
    { value: 'cash', label: 'Espèces', icon: '💵' },
    { value: 'cheque', label: 'Chèque', icon: '📋' },
    { value: 'bank_transfer', label: 'Virement bancaire', icon: '🏦' },
    { value: 'credit_card', label: 'Carte de crédit', icon: '💳' }
  ];
  

  const handleConfirm = () => {
    if (!selectedMethod) {
      alert('Veuillez sélectionner une méthode de paiement');
      return;
    }
    onConfirm(selectedMethod);
    setSelectedMethod(''); // Reset for next time
  };

  const handleClose = () => {
    setSelectedMethod('');
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed text-left inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-[99]">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md mx-4">
        <div className="flex items-center justify-between p-4 border-b">
          <h3 className="text-sm font-semibold text-gray-900">
            Choisir la méthode de paiement
          </h3>
          <button
            onClick={handleClose}
            className="text-gray-700 p-1 cursor-pointer hover:bg-red-400 hover:text-white rounded-full  transition-colors"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="p-4">
          <p className="text-xs text-gray-600 mb-4">
            Sélectionnez la méthode de paiement utilisée pour régler cette facture :
          </p>

          <div className="space-y-2 mb-6">
            {paymentMethods.map((method) => (
              <label
                key={method.value}
                className={`flex items-center p-3 border rounded-2xl cursor-pointer transition-all ${
                  selectedMethod === method.value
                    ? 'border-[var(--color-primary-500)] bg-[var(--color-primary-100)]'
                    : 'border-gray-200 hover:border-gray-300'
                }`}
              >
                <input
                  type="radio"
                  name="paymentMethod"
                  value={method.value}
                  checked={selectedMethod === method.value}
                  onChange={(e) => setSelectedMethod(e.target.value)}
                  className="h-4 w-4 text-[var(--color-primary-500)] focus:ring-[var(--color-primary-500)] border-gray-300"
                />
                <span className="ml-3 text-lg">{method.icon}</span>
                <span className="ml-2 text-xs font-medium text-gray-900">
                  {method.label}
                </span>
              </label>
            ))}
          </div>

          <div className="flex justify-end gap-3">
            <button
              onClick={handleClose}
              disabled={isLoading}
              className="px-4 py-1.5 text-xs font-medium cursor-pointer text-gray-500 bg-gray-100 border border-gray-300 rounded-full hover:bg-gray-200 transition-colors disabled:opacity-50"
            >
              Annuler
            </button>
            <button
              onClick={handleConfirm}
              disabled={isLoading || !selectedMethod}
              className="px-4 py-1.5 text-xs font-medium cursor-pointer text-white bg-[var(--color-primary-500)] border border-transparent rounded-full hover:bg-[#089c8a] transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isLoading ? 'Traitement...' : 'Confirmer le paiement'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}